import {
  useMutation,
  useQuery,
  useQueryClient,
  type QueryClient,
} from '@tanstack/react-query';
import { http } from '@/lib/ats-https';

export const scorecardVisibilityKeys = {
  all: ['scorecard-visibility-settings'],
};

const getScorecardVisibilitySettings = async () => {
  const response = await http.get(`/ats_scorecards/settings`);
  return response;
};

const updateScorecardVisibilitySettings = async (payload) => {
  const response = await http.put(`/ats_scorecards/settings`, payload);
  return response;
};

export const API_SERVICE = {
  getScorecardVisibilitySettings,
  updateScorecardVisibilitySettings,
};

// The interview page reads these on mount; boot starts them alongside the
// interview so they do not wait for the page to render first.
export const prefetchScorecardVisibilitySettings = (queryClient: QueryClient) =>
  queryClient.prefetchQuery({
    queryKey: scorecardVisibilityKeys.all,
    queryFn: () => API_SERVICE.getScorecardVisibilitySettings(),
  });

export const useScorecardVisibilitySettings = (options = {}) =>
  useQuery({
    queryKey: scorecardVisibilityKeys.all,
    queryFn: () => API_SERVICE.getScorecardVisibilitySettings(),
    staleTime: 0,
    ...options,
  });

export const useUpdateScorecardVisibilitySettings = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: API_SERVICE.updateScorecardVisibilitySettings,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: scorecardVisibilityKeys.all });
    },
  });
};
